import styled from 'styled-components'

import { mediaPrintRemoveMargPaddBackg, tableCss } from '../../styles'

export const TableDiv = styled.div`
  ${mediaPrintRemoveMargPaddBackg}
  ${tableCss}
`
